<!-- hidden label to calculate if there is a label or not -->
<app-label-inflator #labelCalculator hidden [labelComponentInterface]="card"></app-label-inflator>

<div class="half-image-card-container" #productCard>
  <!-- Image -->
  <app-asset
    *ngIf="viewModel.hasAsset$ | async; else fallbackIcon"
    class="card-half-image-asset"
    [asset]="card | method: 'getAsset'"
    [style.bottom.px]="assetBottom$ | async">
  </app-asset>
  <ng-template #fallbackIcon>
    <img
      class="card-half-image-asset card-fallback-icon"
      [style.height.px]="iconHeight$ | async"
      [src]="viewModel.assetFallBackIconUrl$ | async"
      alt="" />
  </ng-template>
  <div fxLayout="column" fxLayoutAlign="flex-end " class="half-image-overlay" [style.bottom.px]="assetBottom$ | async">
    <app-label-inflator
      *ngIf="labelCalculator.currentLabelText$ | async | exists"
      [style.display]="'block'"
      [style.align-self]="'flex-end'"
      [labelComponentInterface]="card"
      [fitTextParentContainer]="productCard"
      [fitTextPercentageOfParent]="this | method: 'getLabelPercentage'"
      [fitTextDisabled]="false">
    </app-label-inflator>
  </div>

  <!-- card content -->
  <div class="marketing-card-container top-half-of-card" [style.z-index]="11">
    <div class="top-row" fxLayout="row" [style.height.%]="16">
      <app-card-number
        #num
        [style.width]="num.width | async"
        [card]="card"
        [changeBackgroundColor]="false"
        [index]="index">
      </app-card-number>
      <app-asset
        *ngFor="let badge of card | method: 'getBadges'"
        class="half-image-badge-asset"
        [style.width]="num.width | async"
        [asset]="badge.image"></app-asset>
      <app-card-price class="card-price" fxFlex [card]="card"></app-card-price>
    </div>
  </div>

  <div
    class="marketing-card-container bottom-half-of-card"
    fxLayout="column"
    fxLayoutAlign="end stretch"
    [ngStyle]="{
      color: (card | method: 'getCardTextColor'),
      'background-color': (card | method: 'getCardColor') || '#F1F2F3'
    }">
    <div [style.height.%]="12">
      <div
        class="marketing-card-product-name"
        #name
        appFitText
        [percentageOfParent]="this | method: 'getProductNameTextPercentage'"
        [parentContainer]="productCard">
        {{ card | method: 'getProductName' }}
      </div>
    </div>
    <div
      [hidden]="!(card | method: 'getProductDesc')"
      class="marketing-card-product-desc"
      [ngStyle]="{ '-webkit-line-clamp': cardCount < 9 ? '4' : '3' }"
      appFitText
      [percentageOfParent]="this | method: 'getProductDescTextPercentage'"
      [parentContainer]="productCard">
      {{ card | method: 'getProductDesc' }}
    </div>
    <div
      *ngIf="card | method: 'getIsThcAndCbdProduct'"
      class="thc-cbd-size"
      fxLayout="row"
      fxLayoutAlign="space-between">
      <div [style.display]="(card | method: 'getIsCannabinoidRange') ? 'block' : 'contents'">
        <div
          class="marketing-card-product-thc"
          appFitText
          [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
          [parentContainer]="productCard">
          {{ card | method: 'getThcString' }}
        </div>
        <div
          class="marketing-card-product-cbd"
          appFitText
          [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
          [parentContainer]="productCard">
          {{ card | method: 'getCbdString' }}
        </div>
      </div>
      <div
        class="marketing-card-product-size"
        appFitText
        [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
        [parentContainer]="productCard">
        {{ card | method: 'getSizeString' }}
      </div>
    </div>
  </div>
</div>
